import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import YovoImage from '../common/YovoImage';
import { HOST_GROTESK_FAMILY } from '../../theme/tokens/typography';
import {
  DESTINATION_CARD_DESCRIPTION_FALLBACK,
  DESTINATION_CARD_DESCRIPTION_SX,
  DESTINATION_CARD_IMAGE_SX,
  DESTINATION_CARD_LAYOUTS,
  DESTINATION_CARD_TITLE_FALLBACK,
  DESTINATION_CARD_TITLE_SX,
} from './homepageCarousel.constants';
import { cleanHomepageText } from './homepageSections';

/**
 * One destination card in a homepage carousel.
 * Title, description and image are derived once per destination, not on every parent render.
 */
function DestinationCarouselCard({ destination, eager = false, layout = 'fixed', onOpen }) {
  const view = useMemo(() => {
    const title = destination?.cardTitle
      || destination?.output_json?.hero?.title
      || destination?.title
      || destination?.name
      || DESTINATION_CARD_TITLE_FALLBACK;
    const description = destination?.cardDescription
      || cleanHomepageText(destination?.output_json?.hero?.description)
      || DESTINATION_CARD_DESCRIPTION_FALLBACK;
    const src = destination?.cardImage || destination?.output_json?.hero?.image || '';
    return { title, description, src, alt: title };
  }, [destination]);

  return (
    <Box
      data-carousel-card
      data-testid="destination-carousel-card"
      onClick={() => onOpen?.(destination)}
      sx={DESTINATION_CARD_LAYOUTS[layout] || DESTINATION_CARD_LAYOUTS.fixed}
    >
      <YovoImage
        eager={eager}
        src={view.src}
        alt={view.alt}
        width={220}
        height={220}
        sx={DESTINATION_CARD_IMAGE_SX}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px', alignSelf: 'stretch' }}>
        <Typography sx={{ ...DESTINATION_CARD_TITLE_SX, fontFamily: HOST_GROTESK_FAMILY }}>
          {view.title}
        </Typography>
        <Typography sx={{ ...DESTINATION_CARD_DESCRIPTION_SX, fontFamily: HOST_GROTESK_FAMILY }}>
          {view.description}
        </Typography>
      </Box>
    </Box>
  );
}

export default React.memo(DestinationCarouselCard);
